import "./wdyr";
import "navigator.locks";
import "~helpers/prototypes";
import { PalLocalizationHelper, PalMonacoHelper } from "@palamar/fe-library";
import * as Sentry from "@sentry/react";
import { initializeApp } from "firebase/app";
import i18next from "i18next";

import IFrameHelper from "~helpers/IFrameHelper";
import NotificationHelper from "~helpers/NotificationHelper";
import StorageHelper from "~helpers/StorageHelper";
import TokenHelper from "~helpers/TokenHelper";
import { selectLivechat } from "~store/socket/livechat/selectors";

import * as serviceWorker from "./serviceWorker";
import store from "./store";

import "./assets/scss/theme.scss";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "@fontsource/museomoderno/300.css";
import "@fontsource/museomoderno/400.css";
import "@fontsource/museomoderno/500.css";
import "@fontsource/museomoderno/600.css";
import "@fontsource/museomoderno/700.css";

import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/700.css";
// import "./pwa.worker.js";
PalLocalizationHelper.setI18nInstance(i18next);
PalMonacoHelper.setPath(window.location.origin + import.meta.env.VITE_APP_PUBLIC_URL + "/static/monaco-editor/vs");
async function removeAllRegisteredServiceWorkers() {
  let isRemoved = false;

  if (!("serviceWorker" in navigator)) {
    return false;
  }
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      if (registration.active?.scriptURL?.includes(NotificationHelper.serviceWorkerName)) {
        continue;
      }
      await registration.unregister();
      isRemoved = true;
    }
  } catch {}
  return isRemoved;
}

// import * as OfflinePluginRuntime from "@lcdp/offline-plugin/runtime";

// OfflinePluginRuntime.install();
const firebaseConfig = {
  apiKey: "AIzaSyCsc42zStAlg0aIDmp7-qTEXAaRHMGVbKQ",
  authDomain: "notification-test-8c04e.firebaseapp.com",
  projectId: "notification-test-8c04e",
  storageBucket: "notification-test-8c04e.firebasestorage.app",
  messagingSenderId: "984838892244",
  appId: "1:984838892244:web:3aa16a47ffd95212c46941",
};

initializeApp(firebaseConfig);

// import FirebaseHelper from "~helpers/FirebaseHelper";
//eslint-disable-next-line
// import PushWorker from "worker-loader!./pwa.worker.js";

// setTimeout(() => {
//   // const pw = new PushWorker();
//   // //request push notification permission
//   // // pw.postMessage({ type: "REQUEST_PERMISSION" });
//   // Notification.requestPermission().then(function (permission) {
//   //   // If the user accepts, let's create a notification
//   //   if (permission === "granted") {
//   //     // new Notification("Notification with ServiceWorker");
//   //   }
//   // });
//   //eslint-disable-next-line
//   // const wp = __webpack_require__.p + "static/js/pwa.worker.js";
//   if ("serviceWorker" in navigator) {
//     navigator.serviceWorker
//       .register("/pwa.worker.js")
//       .then(function (registration) {
//         console.log("Service Worker registration successful", registration);
//       })
//       .catch(function (error) {
//         console.log("Service Worker registration failed:", error);
//       });
//   }

//   Notification.requestPermission().then(async function (permission) {
//     // If the user accepts, let's create a notification
//     if (permission === "granted") {
//       self.registration.showNotification("Notification with ServiceWorker");
//       console.log("messaging:", FirebaseHelper.messaging);

//       const token = await FirebaseHelper.messaging.getToken();
//       if (token) {
//         console.log("FCM Token:", token);
//         // API çağrısıyla tokeni sunucuya gönderin
//         fetch("https://your-django-app.com/register", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             token,
//           }),
//         });
//       }
//     }
//   });
// }, 3000);

//Add viewport height variable for mobile browser support
const initialVh = window.innerHeight * 0.01;
const isViewportSupported = "visualViewport" in window;
document.documentElement.style.setProperty("--vh", `${initialVh}px`);
document.documentElement.style.setProperty(
  "--vph",
  `${isViewportSupported ? window.visualViewport.height : initialVh}px`
);

window.addEventListener("resize", function () {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
  if (!isViewportSupported) {
    document.documentElement.style.setProperty("--vph", `${vh}px`);
  }
});

if (isViewportSupported) {
  window.visualViewport.addEventListener("resize", () => {
    document.documentElement.style.setProperty("--vph", `${window.visualViewport.height / 100}px`);
  });
}

StorageHelper.initialize(TokenHelper.getWebchatProjectToken());
window.pr_version = __PR_RELEASE__;
const isSentryEnabled = import.meta.env.PROD && !window.pr_config.sentryDisabled;
if (isSentryEnabled) {
  Sentry.init({
    dsn:
      window.pr_config.sentryDSN ??
      "https://007cbc20dbb507d6523578ab42e0f5c8@o4507358395891712.ingest.de.sentry.io/4507358439931984",
    // integrations: [new Sentry.replayIntegration(), new Sentry.browserTracingIntegration()],
    environment: window.pr_config.sentryEnv ?? (import.meta.env.DEV ? "development" : "production"),
    tracesSampleRate: window.pr_config.sentryTracesSampleRate ?? 1,
    replaysSessionSampleRate: window.pr_config.sentryReplaysSessionSampleRate ?? 0.1,
    replaysOnErrorSampleRate: window.pr_config.sentryReplaysOnErrorSampleRate ?? 1.0,
    release: __PR_RELEASE__,
    normalizeDepth: 6,
    tracePropagationTargets: ["localhost", /^https:\/\/(.*\.)?palmate\.(ai|net)\/api/],
    beforeSend(event, hint) {
      //exclude all Axios based errors
      const error = hint?.originalException;
      const isErrorFromAxios = error?.isAxiosError;
      if (isErrorFromAxios) {
        return null;
      }
      //add extra info
      try {
        event.extra = event.extra || {};

        const livechatState = selectLivechat(store.getState());

        const isWebchatMode = IFrameHelper.isWebChatMode();
        if (isWebchatMode) {
          event.user = event.user || {};

          event.user.userType = "webchat";
        }

        delete event.extra.chatbot?.socketInstance;
        delete event.extra.chatbot?.socket?.welcomeOptions;
        if (event.extra.chatbot?.socket?.messages?.length > 0) {
          event.extra.chatbot.socket.messages = [...event.extra.chatbot.socket.messages].slice(-3);
        }
        if (event.extra.chatbot?.socket?.rawMessages?.length > 0) {
          event.extra.chatbot.socket.rawMessages = [...event.extra.chatbot.socket.rawMessages].slice(-3);
        }
        event.extra.livechat = {
          ...livechatState,
          sessionCount: livechatState?.sessions?.length || 0,
        };
        if (event.extra.livechat.sessions?.length > 0) {
          event.extra.livechat.sessions = [...event.extra.livechat.sessions].map((s) => {
            return {
              id: s?.id,
              bot: s?.bot,
              bot_name: s?.bot_name,
              ticket_enabled: s?.ticket_enabled,
              direct_to_ticket_enabled: s?.direct_to_ticket_enabled,
              feedback_enabled: s?.feedback_enabled,
              chatbot_enabled: s?.chatbot_enabled,
              history_count: s?.history_count,
              created: s?.created,
              listen_type: s?.listen_type,
              platform: s?.platform,
              queue_join_time: s?.queue_join_time,
              last_status: s?.last_status,
              last_agent: s?.last_agent,
              lastMessage: s?.messages?.length > 0 ? { ...s.messages[s.messages.length - 1] } : null,
            };
          });
        }
        delete event.extra.livechat.projectSettings;
      } catch (error) {}
      return event;
    },
  });
  (async () => {
    try {
      const { replayIntegration } = await import("@sentry/react");
      Sentry.addIntegration(
        replayIntegration({
          maskAllText: false,
          blockAllMedia: true,
        })
      );
      const { browserTracingIntegration } = await import("@sentry/react");
      Sentry.addIntegration(browserTracingIntegration());
    } catch (error) {
      console.error("Error while adding Sentry integrations", error);
    }
  })();
}
Error.stackTraceLimit = 25;
window.pr_app_info = function () {
  const logger = (...params) => {
    window.prLog(...params);
    console.log(...params);
  };
  logger(
    /* ANSI Shadow Font*/
    "%c" +
      `
      Powered by 
      ██████╗  █████╗ ██╗     ███╗   ███╗ █████╗ ████████╗███████╗
      ██╔══██╗██╔══██╗██║     ████╗ ████║██╔══██╗╚══██╔══╝██╔════╝
      ██████╔╝███████║██║     ██╔████╔██║███████║   ██║   █████╗  
      ██╔═══╝ ██╔══██║██║     ██║╚██╔╝██║██╔══██║   ██║   ██╔══╝  
      ██║     ██║  ██║███████╗██║ ╚═╝ ██║██║  ██║   ██║   ███████╗
      ╚═╝     ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝╚═╝  ╚═╝   ╚═╝   ╚══════╝               
      Version: ${__PR_RELEASE__}
      `,
    "color:#28aae1; font-size: 10px; font-weight: bold"
  );
};

window.prLog = console.log;
let localStorageEnableLog;
try {
  //try to handle url params log=1
  const urlParams = new URLSearchParams(window.location.search);
  localStorageEnableLog = urlParams.get("log");
  if (localStorageEnableLog) {
    localStorage.setItem("log", localStorageEnableLog);
  } else {
    localStorageEnableLog = localStorage.getItem("log");
  }

  //For enable access *.map files
  if (localStorageEnableLog) {
    document.cookie = `log=1; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
  }
} catch {}

if (!localStorageEnableLog && import.meta.env.VITE_APP_BUILD_ENV !== "development" && !import.meta.env.DEV) {
  // Disable console.log in production
  window._log = console.log;
  console.log = () => {};
  console.enableLog = () => {
    console.log = window._log;
    serviceWorker.getSwInstance().then((sw) => {
      sw?.postMessage({ type: "ENABLE_LOG" });
    });
  };
} else {
  serviceWorker.getSwInstance().then((sw) => {
    sw?.postMessage({ type: "ENABLE_LOG" });
  });
}

window.__e = () => {
  throw new Error("Hello Sentry");
};

// if (import.meta.env.DEV) {
//   //Auto skip waiting for service worker
//   if ("serviceWorker" in navigator) {
//     navigator.serviceWorker.ready.then((registration) => {
//       registration.waiting?.postMessage({ type: "SKIP_WAITING" });
//     });
//   }
// }

// if (import.meta.env.PROD) {
// serviceWorker.register();
// } else {
//  serviceWorker.unregister();
// }

removeAllRegisteredServiceWorkers();

let lastVisitedTime = Date.now();
document.addEventListener("visibilitychange", function () {
  if (document.visibilityState === "visible") {
    //if last visited time is more than 2 hour ago, then check for new version
    if (Date.now() - lastVisitedTime > 2 * 60 * 60 * 1000) {
      fetch(`${window.pr_config?.baseUrl}/static/version.json`, {
        cache: "no-store",
        headers: {
          cache: "no-store",
          "cache-control": "no-cache",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (typeof data?.v === "string" && data.v !== __PR_RELEASE__) {
            window.location.reload(true);
          }
        })
        .catch(() => {});
    }
    lastVisitedTime = Date.now();
  }
});
